const getFormValue = (form) => {
  const values = {};

  [...form.elements].forEach((item) => {
    if (item.type === "checkbox") {
      values[item.name] = item.checked;
    } else if (item.name && item.value) {
      values[item.name] = item.value;
    }
  });

  return values;
};

export default getFormValue;
